export const isProduction = () => {
  return process.env.VERCEL_ENV === "production";
};

export const isStaging = () => {
  return process.env.IS_STAGING === "true";
};
